import { useEvidenceUpload } from "./useAPI";

export const useFileDownload = () => {
  const [, getEvidence] = useEvidenceUpload(
    {
      url: `/file`,
      method: "POST",
    },
    { manual: true }
  );

  const downloadFile = async (url) => {
    const data = await getEvidence({
      data: { url },
    });

    const splitUrl = url.split(/\/(?=[^\/]+$)/);
    const [, fileName] = splitUrl;

    if (data.data?.Body) {
      const bytes = new Uint8Array(data.data?.Body.data);
      const blob = new Blob([bytes], { type: data.data.ContentType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      link.download = fileName;
      link.click();
    }
  };

  return { downloadFile };
};
